export const REDUCER_NAME = "nationalTopScorers";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NATIONALTEAMTOPSCORERS = `${REDUCER_NAME}/SET_NATIONALTEAMTOPSCORERS`;

export const getKey = (data) => `${data.nationalTeamId}`;
